export class ChartDrillDownData
{
    public  Level :string;
    public  Id :string;
    public  dataset :ChartDataDetails[];
    public sequentialChartType:ChartTypeOnSequence[];

}

export class ChartDataDetails{   
        public  Dataset : ChartDataSet[]
        public  Id:string;
        public  ParentId :string;
        public  ParentVal :string;
        public  DataId :string[];
        public  chartLabels: string[];
        public  SeqNumber :number;
}

export class ChartDataSet
{
    public  Data:number[];
    public Label :string;
}

export class ChartTypeOnSequence
    {
        public  sequnceNumber :number;
        public  chartType :string;
        public  chartTitle :string;

    }